module.exports = __webpack_public_path__ + "img/26.9fc1fcb0.png";